import React, {Component} from 'react';
import { Button } from 'react-bootstrap';
import Dropzone from 'react-dropzone';

import { REST_API_URL } from "../../Utils/Global";

/**
* Class FileUpload
* Generic component to generate file upload fields
**/
class FileUpload extends Component {
  /**
  * props
  * mode : readonly/add/edit
  * existing : name of existing file
  * getPath : path to get file
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {
      file: undefined,
      existing: props.existing
    };
  }

  /**
  * componentWillReceiveProps
  * Update state if needed
  **/
  componentWillReceiveProps(nextProps) {
    if(this.props.existing !== nextProps.existing) {
      let state = this.state;
      state.existing = nextProps.existing;
      this.setState(state);
    }
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    // Uploaded file OR existing file OR nothing
    let currentLabel = (this.state.file !== undefined) ? this.state.file.name : (this.state.existing !== undefined) ? this.state.existing : "Déposer un fichier";

    let browseButton = null;
    let deleteButton = null;
    if(this.props.mode !== "readonly") {
      browseButton = <Button bsStyle="primary" onClick={this.onBrowseClick.bind(this)}>Parcourir</Button>;
      deleteButton = <Button bsStyle="danger" onClick={this.onClearClick.bind(this)}><span className="glyphicon glyphicon-remove"></span></Button>;
    }

    // Existing file : button to open
    let viewButton = null;
    if(this.state.existing) {
      viewButton = <Button bsStyle="default" onClick={this.onOpenClick.bind(this)}><span className="glyphicon glyphicon-download-alt"></span></Button>
    }

    // Accepted files
    let fileAccepted = this.props.mode === "readonly" ? "none" : "";
    if(this.props.accept) {
      fileAccepted = this.props.accept;
    }

    return (
      <div className="fileUploadContainer">
        <Dropzone accept={fileAccepted} disableClick={this.props.mode === "readonly"} multiple={false} ref="dropzone" onDrop={this.onDrop.bind(this)}>
          <p className="fileUploadInnerDropzone">{ currentLabel }</p>
        </Dropzone>
        {browseButton}
        {deleteButton}
        {viewButton}
      </div>
    );
  }

  /**
  * onBrowseClick
  * Open explorer to choose file
  **/
  onBrowseClick() {
    this.refs.dropzone.open();
  }

  /**
  * onDrop
  * Handle file selection (drop and from explorer)
  **/
  onDrop(files) {
    this.setState({
      file: files[0]
    });

    if(this.props.onChange) {
      this.props.onChange.call(this, this, files[0]);
    }
  }

  /**
  * onClearClick
  * Handle field clear
  **/
  onClearClick() {
    this.setState({
      file: undefined,
      existing: (this.state.existing === undefined) ? undefined : false // False => clear value, undefined => nothing to do
    });

    if(this.props.onClear) {
      this.props.onClear.call(this, this);
    }
  }

  /**
  * onOpenClick
  * Handle open file click
  **/
  onOpenClick() {
    open(REST_API_URL + this.props.getPath);
  }

  /**
  * getFile
  * Returns the current uploaded file
  **/
  getFile() {
    return this.state.file;
  }

  /**
  * getExisting
  * Returns the existing file
  **/
  getExisting() {
    return this.state.existing;
  }

}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/views/Helper/FileUpload.js